import './photobanner.css'

const PhotoBanner = ({ values }) => {

  const groomNameDisplay = () => {
    return (
      <span
        className="wed-detail-name"
        style={{ fontFamily: values.nameFontStyle }}
      >
       {values.groomName || "Groom"}
      </span>
    );
  };

  const brideNameDisplay = () => {
    return (
      <span
        className="wed-detail-name"
        style={{ fontFamily: values.nameFontStyle }}
      >
      {values.brideName || "Bride"}
      </span>
    );
  };

  return (
  <>
      <div
        className={`preview-container-overlay overlay-align-${values.fontAlignment}`}
      ></div>

      <img
        src={values.bannerImage ? values.bannerImage.url : ''}
        alt="banner-img"
        className='preview-photo-banner-img'
        srcSet={`
          ${values.bannerImage
            ? values.bannerImage.url.replace('/upload/', '/upload/w_320/')
            : ''
          } 320w,

          ${values.bannerImage
            ? values.bannerImage.url.replace('/upload/', '/upload/w_640/')
            : ''
          } 640w,

          ${values.bannerImage
            ? values.bannerImage.url.replace('/upload/', '/upload/w_640/')
            : ''
          } 1080w
        `}
        sizes="
          (max-width: 320px) 320px,
          (max-width: 640px) 640px,
          (max-width: 1080px) 1080px
        "
      />

      <div
        className={`wed-details-container align-${values.fontAlignment}`}
        style={{ color: values.fontColor }}
      >

        {values.displayOrder === "groomFirst" ? (
          <>
            {groomNameDisplay()}

            <span
              className="wed-detail-and"
              style={{ fontFamily: values.nameFontStyle }}
            >
              &
            </span>

            {brideNameDisplay()}
          </>
        ) : (
          <>
            {brideNameDisplay()}

            <span
              className="wed-detail-and"
              style={{ fontFamily: values.nameFontStyle }}
            >
              &
            </span>

            {groomNameDisplay()}
          </>
        )}

     <span className="wed-detail-hastag">
      {values.hashtag ? `#${values.hashtag}` : ""}
</span>
      </div>

 </>
  );
};

export default PhotoBanner;